const PROFILE_TYPE_ADVISOR = 'Advisor'
const PROFILE_TYPE_COLLABORATOR = 'Collaborator'
const PROFILE_TYPE_CLIENT = 'Client'
const ALL_TAB = 0
const ACTIVE_TAB = 1
const INACTIVE_TAB = 2
const ADMIN_PROFILE_ID = 1
const ACTIVE = true
const INACTIVE = false

const NEWLY_CREATED = 'newly_created'
const OLDER_CREATED = 'older_created'

const TABS = [
  {
    value: ALL_TAB,
    label: 'Todos',
  },
  {
    value: ACTIVE_TAB,
    label: 'Ativos',
  },
  {
    value: INACTIVE_TAB,
    label: 'Inativos',
  },
]

const CLIENT_KIND = 'client'
const ADVISOR_KIND = 'advisor'

const PLATFORM_KIND = { [CLIENT_KIND]: 'APP', [ADVISOR_KIND]: 'Advisor' }

const user = {
  ACTIVE,
  ACTIVE_TAB,
  ADVISOR_KIND,
  ADMIN_PROFILE_ID,
  ALL_TAB,
  INACTIVE,
  INACTIVE_TAB,
  NEWLY_CREATED,
  OLDER_CREATED,
  PLATFORM_KIND,
  PROFILE_TYPE_ADVISOR,
  PROFILE_TYPE_CLIENT,
  PROFILE_TYPE_COLLABORATOR,
  TABS,
}

export default user
